package com.wintermar.inspection.core.ui.component.modal.util

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.button.Button
import com.wintermar.inspection.core.ui.component.button.variant.ButtonVariant
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun ModalActionContent(
    isBottomSheet: Boolean = false,
    action: ModalActionModel
) {
    if (!action.showAction) {
        return
    }

    val dimension = LocalAppTheme.current.dimension
    val color = LocalAppTheme.current.color
    val firstWeight =
        if (action.isSameWeight) 1f else action.label.length.coerceAtLeast(1).toFloat()
    val secondWeight =
        if (action.isSameWeight) 1f else action.secondLabel?.length?.coerceAtLeast(1)?.toFloat()
            ?: 0f

    Column(
        modifier = Modifier.fillMaxWidth()
            .then(
                if (isBottomSheet) Modifier.background(
                    color = color.surface.normal,
                ) else Modifier.background(
                    color = color.surface.normal,
                    shape = RoundedCornerShape(
                        bottomStart = dimension.radius.lg,
                        bottomEnd = dimension.radius.lg
                    )
                )
            )
    ) {
        HorizontalDivider(
            modifier = Modifier.fillMaxWidth(),
            color = color.border.subtle
        )
        Column(
            modifier = Modifier
                .padding(
                    horizontal = dimension.spacing.space4,
                    vertical = dimension.spacing.space3
                )
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space2,
                    alignment = if (action.widthButtonBasedOnText) Alignment.End else Alignment.Start
                ),
                verticalAlignment = Alignment.CenterVertically
            ) {
                action.secondLabel?.let {
                    Button(
                        buttonVariant = ButtonVariant.MediumOutline,
                        disabled = action.disableSecondOnClicked,
                        text = it,
                        modifier = if (!action.widthButtonBasedOnText) Modifier.weight(secondWeight) else Modifier,
                        onClick = action.secondOnClick
                    )
                }

                Button(
                    buttonVariant = if (action.isDangerAction) ButtonVariant.MediumDanger
                    else ButtonVariant.MediumPrimary,
                    disabled = action.disableOnClicked,
                    text = action.label,
                    modifier = if (!action.widthButtonBasedOnText) Modifier.weight(firstWeight) else Modifier,
                    onClick = action.onClick
                )
            }
        }
    }
}
